export const getNewsId = async (newsId) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/projects/api/news/details/${newsId}`,
      {
        method: "GET",
      }
    );
    return await response.json();
  } catch (error) {
    throw error;
  }
};
